<template>
  <div class="TradeList">
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="100px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="时间范围">
          <el-date-picker
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="bedata"
            @change="timechange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="primary" @click="clearsearchQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_div">
      <el-table
        :data="tradeList"
        border
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
        :default-expand-all="false"
        style="width: 100%"
      >
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="tradeWay" label="交易方式">
          <template slot-scope="scope">
            <span v-if="scope.row.tradeWay == '0'">投递可回收物</span>
            <span v-if="scope.row.tradeWay == '1'">线下商店消费</span>
          </template>
        </el-table-column>
        <el-table-column prop="tradeCate" label="交易方向">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.tradeCate == '0'"
              >收入</span
            >
            <span style="color: red" v-if="scope.row.tradeCate == '1'"
              >支出</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="tradeCoin" label="环保金"></el-table-column>
        <el-table-column prop="tradeCount" label="交易次数"></el-table-column>
        <el-table-column prop="tradeUsers" label="交易人数"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { tradedataStatis } from "@/api/management";
import { publicMixin } from "@/mixins/publicMixin";
import { getLast7Days } from '@/utils/util';
export default {
  name: "TradeList",
  props: {},
  mixins: [publicMixin],
  data() {
    return {
      bedata: "",
      queryParam: {
        end: "",
        start: "",
      },
      tradeList: [],
    };
  },
  created() {
    // var myDate = new Date();
    // // 获取 特定日期 之前的 第七天
    // let tmpArr = [];
    // tmpArr.push(
    //   moment(myDate.setDate(myDate.getDate() - 7)).format("YYYY-MM-DD HH:mm:ss")
    // );
    // tmpArr.push(moment(new Date().valueOf()).format("YYYY-MM-DD HH:mm:ss"));
    // this.bedata = tmpArr;
    // this.queryParam.start = this.bedata[0];
    // this.queryParam.end = this.bedata[1];
    this.bedata = getLast7Days();
    this.timechange(this.bedata);
    this.getDataList();
  },
  methods: {
    timechange(val) {
      console.log(val);
      this.queryParam.start = val[0];
      this.queryParam.end = val[1];
    },
    searchQuery() {
      this.getDataList();
    },
    clearsearchQuery() {
      for (let key in this.queryParam) {
        this.queryParam[key] = "";
      }
      this.getDataList();
    },
    getDataList() {
      let obj = JSON.parse(JSON.stringify(this.queryParam));
      obj.end = obj.end;
      obj.start = obj.start;
      tradedataStatis(obj).then((res) => {
        if (res.code == 200) {
          this.tradeList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.TradeList {
  padding: 18px;
  .search_wrap {
    margin-top: 20px;
  }
  .statistics {
    width: 325px;
    display: flex;
    justify-content: space-between;
    div {
      width: 150px;
      border-radius: 12px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .table_div {
    margin-top: 20px;
  }
  .add {
    margin-top: 20px;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
